import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import RupeeCell from "application/components/RupeeCell";
import { BillingReportMenu } from "globals/configuration/BillingReportMenu";

const Attributes = {
  enableAddButton: false,
  enableUpdateTableRecords: true,
  enableDownloadButton: true,
  enableAdvanceSearch: true,
  enableDownloadPdf: true,
  enableRefresh: true,
  modes: BillingReportMenu.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
};

const operationURLS = {
  list: "/extensionSummary/listExtensionDetail",
  pdfDownload: "extensionSummary/generateAndDownloadextensionDetailPdf",
  csvDownload: "/extensionSummary/downloadCSVextensionSummaryDetail",
};

const getColumns = () => {
  return [
    {
      Header: "Extension No",
      accessor: "callerId",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
        {
      Header: "Extension Name",
      accessor: "callerName",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Intercom Call",
      accessor: "intercomCall",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      dateTime: false,
      sortDisable: true,
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "Intercom Cost",
      accessor: "intercomCost",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value, row }) => <RupeeCell value={value} row={row} />,
    },
    {
      Header: "Local Call",
      accessor: "localCall",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Local Cost",
      accessor: "localCost",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
    {
      Header: "STD Call",
      accessor: "stdCall",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "STD Cost",
      accessor: "stdCost",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
    {
      Header: "ISD Call",
      accessor: "isdCall",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ISD Cost",
      accessor: "isdCost",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
    {
      Header: "Total Call",
      accessor: "totalCall",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Cost",
      accessor: "totalCost",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
    {
      Header: "Date",
      accessor: "callDate",
      displayInList: false,
      allowInForm: false,
      allowFilter: true,
      dataType: "date",
      dateTime: false,
      downloadReports: false,
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
  ];
};

export { getColumns, Attributes, operationURLS };
